import React from "react";
import "./componentStyles/UnitMonthlyTable.css";

export default function UnitMonthlyTable({ data, loading, onMonthChange, editable, onCellChange }) {
  if (loading) return <div className="umt-muted">Yükleniyor...</div>;
  if (!data) return <div className="umt-muted">Veri yok.</div>;

  const days = data.days || [];
  const rows = data.rows || [];

  // Pad with empty rows so table looks filled
  const MIN_ROWS = 12; // adjust if you want taller table
  const placeholders =
    rows.length < MIN_ROWS
      ? Array.from({ length: MIN_ROWS - rows.length }, (_, i) => ({ __empty: true, key: `emt-${i}` }))
      : [];
  const displayRows = [...rows, ...placeholders];

  const headerCells = [
    <th key="order" className="umt-th umt-col-order">Sıra</th>,
    <th key="name" className="umt-th umt-col-name">Ad - Soyad</th>,
    ...days.map(d => (
      <th
        key={d.date}
        className={`umt-th umt-col-day ${d.weekend ? "weekend" : ""}`}
        title={d.date}
      >
        {d.day}
      </th>
    )),
    <th key="total" className="umt-th umt-col-total">Toplam Saat</th>
  ];

  return (
    <div className="umt-wrapper">
      <div className="umt-topbar">
        <div className="umt-title">
          {data.unit?.birimAdi || ""}
        </div>
        <div className="umt-actions">
          <input
            className="umt-month"
            type="month"
            value={data.month}
            onChange={(e) => onMonthChange?.(e.target.value)}
          />
        </div>
      </div>

      <div className="umt-table-wrap">
        <table className="umt-table">
          <thead>
            <tr>{headerCells}</tr>
          </thead>
          <tbody>
            {displayRows.map((r) => {
              if (r.__empty) {
                const emptyCells = [
                  <td key={`${r.key}-order`} className="umt-td umt-center empty">&nbsp;</td>,
                  <td key={`${r.key}-name`} className="umt-td umt-nowrap umt-name-cell empty">&nbsp;</td>,
                  ...days.map((d) => (
                    <td key={`${r.key}-${d.date}`} className={`umt-td umt-center umt-day-cell ${d.weekend ? "weekend" : ""} empty`}>
                      &nbsp;
                    </td>
                  )),
                  <td key={`${r.key}-total`} className="umt-td umt-center umt-strong empty">&nbsp;</td>
                ];
                return <tr key={r.key} className="umt-row-empty">{emptyCells}</tr>;
              }

              const dayCells = days.map(d => {
                const v = r.perDay?.[String(d.day)] || 0;
                return (
                  <td
                    key={`${r.studentSicilNo}-${d.date}`}
                    className={`umt-td umt-center umt-day-cell ${d.weekend ? "weekend" : ""}`}
                  >
                    {editable ? (
                      <input
                        type="text"
                        inputMode="numeric"
                        pattern="[0-7]"
                        maxLength={1}
                        value={v}
                        disabled={d.weekend}
                        onChange={e => {
                          if (d.weekend) return;
                          const val = e.target.value;
                          if (/^[0-7]$/.test(val)) {
                            onCellChange?.(r.studentSicilNo, String(d.day), parseInt(val, 10));
                          } else if (val === "") {
                            onCellChange?.(r.studentSicilNo, String(d.day), 0);
                          }
                        }}
                        onKeyDown={e => {
                          if (d.weekend) {
                            e.preventDefault();
                            return;
                          }
                          if (
                            !(
                              (e.key >= "0" && e.key <= "7") ||
                              ["Backspace", "Delete", "Tab", "ArrowLeft", "ArrowRight"].includes(e.key)
                            )
                          ) {
                            e.preventDefault();
                          }
                        }}
                        style={{
                          width: "15px",
                          height: "20px",
                          textAlign: "center",
                          fontSize: "14px",
                          padding: "0px 0",
                          border: "none",
                          background: d.weekend ? "#f3f3f3" : undefined,
                          color: d.weekend ? "#b0b0b0" : undefined,
                          cursor: d.weekend ? "not-allowed" : undefined
                        }}
                      />
                    ) : (
                      v > 0 ? v : ""
                    )}
                  </td>
                );
              });

              const rowCells = [
                <td key={`${r.studentSicilNo}-order`} className="umt-td umt-center">{r.order}</td>,
                <td key={`${r.studentSicilNo}-name`} className="umt-td umt-nowrap umt-name-cell">{r.studentName}</td>,
                ...dayCells,
                <td key={`${r.studentSicilNo}-total`} className="umt-td umt-center umt-strong">{r.totalHours}</td>
              ];

              return <tr key={r.studentSicilNo}>{rowCells}</tr>;
            })}
          </tbody>
        </table>
      </div>

      <div className="umt-note">
        Not: Hafta sonları gri arka plan ile gösterilir. Hücrelerdeki değer o gündeki toplam saat sayısını ifade eder.
      </div>
    </div>
  );
}
